import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BehaviorSubject, of, Subject, Subscription} from 'rxjs';
import {RequestStatus} from 'src/app/models/request-status';
import {AckRequestService} from 'src/app/services/ack-request.service';
import {ApiRoutes} from 'src/app/services/apiroutes';
import {AuthService} from 'src/app/services/auth.service';
import {RequestApiService} from 'src/app/services/domain_code/request-api.service';
import {ReleaseOrderComponent} from '../release-order/release-order.component';
import {ReturnOrderComponent} from '../return-order/return-order.component';
import {DepotFormComponent} from '../depot-form/depot-form.component';
import {IRequestModel} from '../my-orders-table/new-request.model';
import {MyOrdersTableComponent} from '../my-orders-table/my-orders-table.component';
import {MatDialog} from '@angular/material/dialog';
import {NotificationBoxComponent} from '../../dialog-box/notification-box/notification-box.component';
import {CommonService} from 'src/app/common.service';
import {InfoContentComponent} from '../info-content/info-content.component';
import {LeaseQuoteModel} from '../quoteTable/lease-quote-table/lease-quote';
import {LeaseQuoteTableComponent} from '../quoteTable/lease-quote-table/lease-quote-table.component';
import {LeaseQuoteTableService} from '../quoteTable/lease-quote-table/lease-quote-table.service';
import {ReleaseOrderService} from 'src/app/services/release-order.service';
import {ChatService} from 'src/app/services/chat.service';
import {PickupReturnComponent} from '../pickup-return/pickup-return.component';
import {environment} from 'src/environments/environment';
import { GlobalLoaderService } from 'src/app/services/global-loader.service';

export interface req {
    commercials: string;
    currentQuote: string;
    lastQuote: string;
}

interface reqAtn {
    icon?: string;
    value?: string;
    title?: string;
    submenu?: any[] | RequestStatus[];

}

@Component({
    selector: 'logzy-request-serve',
    templateUrl: './request-serve.component.html',
    styleUrls: ['./request-serve.component.scss']
})
export class RequestServeComponent implements OnInit, OnDestroy {
    externalAppUrl = 'invoice/list'
    readTrigger: Subscription;
    request: string;
    request_url = `${ApiRoutes.LeadRequest}request_details/`;
    reviewQuoteData = null;
    request_id = '';
    previousMenu: string = null;
    requestError: boolean;

    locationSourceLabel: string;
    locationDestinationLabel: string;
    review: boolean = false;
    reviewLease: boolean = false;
    @Input()
    refreshRequestDetails = new BehaviorSubject(null);

    quoteList = [];
    menuItems = [];

    leaseBaseQuote: LeaseQuoteModel;
    refreshLeaseQuote = new BehaviorSubject(null);
    refreshOneWayQuote = new BehaviorSubject(null);
    refreshTradeQuote = new BehaviorSubject(null);
    refreshEmptyRepoQuote = new BehaviorSubject(null);

    _possibleStatusChangeList = [];
    @Input() possibleButtonStatuses = [];
    possibleQuickActionStatuses = [];
    newNotificationFlag: boolean = false;
    private _pickupReturnComponent!: PickupReturnComponent;
    @ViewChild(PickupReturnComponent) set pickupReturnComponent(ref: PickupReturnComponent) {
        if (ref) {
            this._pickupReturnComponent = ref;
            console.log('PickupReturnComponent is available:', this._pickupReturnComponent);
            if (this.requestService.selectedRequest?.transaction_type == 'use' || (this.requestService.selectedRequest?.transaction_type == 'supply' && this.requestService.selectedRequest.is_procurement == true)) {
                this._pickupReturnComponent.AddPickup();
            }
        }
    }

    type: string = '';
    rType: string = '';

    get possibleStatusChangeList() {
        return this._possibleStatusChangeList;
    }

    set possibleStatusChangeList(value) {
        this._possibleStatusChangeList = value;
        this.possibleButtonStatuses = this._possibleStatusChangeList.filter(
            (item) =>
                (this.authService.isCustomer() && item.enable_quick_action_button_for_external) ||
                ((!this.authService.isCustomer()) && item.enable_quick_action_button_for_internal)
        );
        this.possibleQuickActionStatuses = this._possibleStatusChangeList.filter(
            (item) =>
                (this.authService.isCustomer() && item.enable_quick_action_link_for_external) ||
                ((!this.authService.isCustomer()) && item.enable_quick_action_link_for_internal)
        );
    }

    negotiate: boolean = true;
    // skipFeedback: boolean = false;
    addRelease: boolean = false;
    addReturn: boolean = false;
    addReexport: boolean = false;
    addMovementDetails: boolean = false;
    viewDetails: boolean = true;
    attention: boolean = true;
    secondaryButton: boolean = true;
    ternaryButton: boolean = true;
    loader: boolean = true;
    celebrate: boolean = false;
    expand: boolean = false;
    action_message: string = "You have got the best rate for the trade lane and equipment selected. Please hurry and accept the Quotation.";
    action1: string = "Negotiate";
    action2: string = "Accept Quote";
    timelineAction1: string = "Collapse";
    unit: number = 12;
    @Output() closeview = new EventEmitter<boolean>();
    @Output() editRequestAndRequirement = new EventEmitter<any>();
    @Output() editLeadRequest = new EventEmitter<any>();
    @Output() editRO = new EventEmitter<any>();
    @Output() nudge = new EventEmitter<any>();
    @Output() cancelReleaseOrder = new EventEmitter<any>();
    @Output() revalidate = new EventEmitter<any>();
    @Output() custrevalidate = new EventEmitter<any>();
    @Output() editPickupS = new EventEmitter<any>();
    @Output() editDropoffS = new EventEmitter<any>();

    @Output() editROrder = new EventEmitter<any>();
    @Output() cancelROrder = new EventEmitter<any>();
    @Output() revalidateROrder = new EventEmitter<any>();
    @Output() custrevalidateROrder = new EventEmitter<any>();

    @Output() depotForm = new EventEmitter<any>();
    @Output() filterForm = new EventEmitter<any>();
    @Output() containerListRO = new EventEmitter<any>();
    @Output() reqContainers = new EventEmitter<any>();
    @Output() reopenLogs = new EventEmitter<any>();
    @Output() bookingViewLogs = new EventEmitter<any>();
    @Output() addInvoiceParty = new EventEmitter<any>();





    @ViewChild(ReleaseOrderComponent) child: ReleaseOrderComponent;
    @ViewChild(ReturnOrderComponent) child1: ReturnOrderComponent;
    @ViewChild(DepotFormComponent) child2: DepotFormComponent;
    @ViewChild(MyOrdersTableComponent) child3: MyOrdersTableComponent;
    @ViewChild(InfoContentComponent) child4: InfoContentComponent;
    @ViewChild(LeaseQuoteTableComponent) leaseQuoteTable: LeaseQuoteTableComponent;

    refreshTable = new Subject();

    requestDetails: IRequestModel;

    showConfirmation: boolean = false;

    changeToStatusCache: RequestStatus = null;
    changeToStatusDevName: string = null;
    changeToStatusName: string = null;

    viewChat: boolean = true;
    reqAction: reqAtn[] = [
        {
            icon: 'enquiry-actions',
            value: 'enquiry-actions',
            title: 'Enquiry Actions',
            submenu: [
                {
                    title: 'Alter Requirement',
                    value: 'alter_requirement',
                },
                {
                    title: 'Accept Requirement',
                    value: 'accept_requirement',
                },
                {
                    title: 'Reject Requirement',
                    value: 'reject_requirement',
                },
                {
                    title: 'Share Requirement',
                    value: 'transfer_requirement',
                },
            ]
        },
        {
            icon: 'quotations',
            value: 'quotations',
            title: 'Quotations'
        },
        {
            icon: 'negotiation',
            value: 'negotiate',
            title: 'Negotiate'
        },
        {
            icon: 'conversation',
            value: 'communication',
            title: 'Communication'
        },
        {
            icon: 'suitcase',
            value: 'operations',
            title: 'Operations',
            submenu: [
                {
                    title: 'Release Order',
                    value: 'release_order',
                },
                {
                    title: 'Pick-up',
                    value: 'pickup_return',
                },
                {
                    title: 'Return Reference',
                    value: 'return_reference',
                },
                {
                    title: 'Return',
                    value: 'return',
                },
            ]
        },
        {
            icon: 'money-growth',
            value: 'revenue',
            title: 'Revenue'
        },
        {
            icon: 'post-booking',
            value: 'post_booking',
            title: 'Post Booking'
        },
        {
            icon: 'snowflake',
            value: 'cold_leads',
            title: 'Cold Leads'
        },
        {
            icon: 'key-insights',
            value: 'key_insights',
            title: 'Key Insights'
        },
    ]
    // viewFormContent: string = 'Transfer Request';
    viewFormContent: string;
    selected_menu = null;
    selected_menu_item = null;

    mode: string = '';
    notGettingDragged: boolean = false;
    mouseDown: boolean = false;
    showReExport: boolean = false;
    reExportContainersList: [] = [];
    // button = document.getElementById('chatButton');

    // data: req[] = DATA;

    bookingDetails;
    bookingChargesList: [] = [];
    requirementContainersList: [] = [];

    editRequest() {
        setTimeout(() => {
            //Bharti Comment
            // this.getRequestDetailsById(this.request_id);
            this.editRequestAndRequirement.emit();
            // this.editLeadRequest.emit();

        }, 300);
    }

    updateLeadRequest(data) {
        setTimeout(() => {
            this.editLeadRequest.emit(data);
        }, 300);
    }

    updatePickUp(data) {
        setTimeout(() => {
            this.editPickupS.emit(data);
        }, 400);
    }

    updateDropoff(data) {
        setTimeout(() => {
            this.editDropoffS.emit(data);
        }, 400);
    }


    updateReleaseOrder() {
        this.child.getAllDOowner();
        this.child.getAllData();
    }

    updateReturnOrder() {
        this.child1.getAllDOowner();
        this.child1.getAllData();
    }

    refreshDepotForm() {
        this.child.getAllData();
    }

    refreshRequestList() {
        // this.child3.getRequestDetailsByFilters();
    }

    refreshLeaseRequestList() {
        this.child4.getAllData();
    }

    editReleaseOrder(data) {
        setTimeout(() => {
            this.editRO.emit(data);
        }, 300);
        this.refreshTable.next("Refresh");
    }

    nudgeClient(data) {
        setTimeout(() => {
            this.nudge.emit(data);
        }, 300);
    }

    cancelRequest(data) {
        this.cancelReleaseOrder.emit(data);
    }

    revalidateRequest(data) {
        // this.revalidate.emit(data);
        setTimeout(() => {
            this.revalidate.emit(data);
        }, 300);
    }

    revalidateCustRequest(data) {
        setTimeout(() => {
            this.custrevalidate.emit(data);
        }, 300);
    }

    editReturnOrder(data) {
        setTimeout(() => {
            this.editROrder.emit(data);
        }, 300);
    }

    cancelRORequest(data) {
        this.cancelROrder.emit(data);
    }

    revalidateRORequest(data) {
        // this.revalidate.emit(data);
        setTimeout(() => {
            this.revalidateROrder.emit(data);
        }, 300);
    }

    revalidateROCustRequest(data) {
        setTimeout(() => {
            this.custrevalidateROrder.emit(data);
        }, 300);
    }

    openDepotForm(data) {
        setTimeout(() => {
            this.depotForm.emit(data);
        }, 300);
    }

    openContainerList(data) {
        setTimeout(() => {
            this.containerListRO.emit(data);
        }, 300);
        this.refreshTable.next("Refresh");
    }

    Expand() {
        this.expand = !this.expand;
    }

    closeView() {
        if (this.review) {
            this.review = false;
        } else if (this.reviewLease) {
            this.reviewLease = false;
        } else if (this.viewFormContent != 'quotations' && this.viewFormContent != 'negotiate' && this.previousMenu != null) {
            if (this.requestService.selectedRequest?.status?.dev_name == 'booking_confirmed') {
                this.closeview.emit(false);
            } else {
                this.viewFormContent = this.previousMenu;
                this.selected_menu = this.previousMenu;
            }
        } else {
            this.closeview.emit(false);
        }
    }

    accepted() {
        this.showConfirmation = true;
    }

    constructor(public requestService: RequestApiService,
                private route: ActivatedRoute,
                private ackRequest: AckRequestService,
                private router: Router,
                private dialog: MatDialog,
                public authService: AuthService,
                public commonService: CommonService,
                public leaseQuoteService: LeaseQuoteTableService,
                public releaseservice: ReleaseOrderService,
                public chatService: ChatService,
                private loaderService: GlobalLoaderService,) {
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.getNotificationMessages();
        }, 5000);

        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.request_id = params['id'];
                this.getRequestDetailsById(params['id']);
                this.getRequestMenuItems(params['id']);
                this.negotiate = true;
            }

            if ('mode' in params) {
                this.mode = params['mode'];
            }

            if ('type' in params && 'rtype' in params) {
                this.type = params['type'];
                this.rType = params['rtype'];
            }
        })

        this.refreshRequestDetails.subscribe(item => {
            if (item) {
                this.route.queryParams.subscribe(params => {
                    if ('id' in params) {
                        this.getRequestDetailsById(params['id']);
                    }
                })
            }
        })
    }

    getNotificationMessages() {
        this.chatService.wsSubject$
            .subscribe({
                next: (msg) => {
                    console.log('new_chat_message ------------->', msg);
                    if (msg.event == 'init_connection') {
                        this.chatService.wsSubject$.subscribe();
                        // console.log(this.newChat);
                        // this.chatService.wsSubject$.next(this.newChat);
                    } else if (msg.event == 'new_chat_message') {
                        this.newNotificationFlag = true;
                        let audio = new Audio();
                        audio.src = "assets/audio/notification.mp3";
                        audio.load();
                        audio.play();
                    }
                    // console.log(this.newNotifications);
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {
                    console.log(
                        'Notifications Socket Disconnected ...............'
                    );
                },
            });
    }

    // ngAfterContentInit(): void {
    // if (this.commonService.quotationData) {
    //     this.quoteList[0].latest_quote = this.commonService.quotationData;
    // }
    //     console.log("what is ",this.possibleButtonStatuses, "lets see", this.possibleButtonStatuses.length > 0)
    // }
    ngOnDestroy(): void {
        if (this.readTrigger) {
            this.readTrigger.unsubscribe();
        }
    }

    editQuote() {
        this.negotiate = !this.negotiate
    }

    default_currency: any;

    getRequestDetailsById(id) {
        console.log('Getting request details');
        if (id == null) {
            return;
        }
        this.requestService.getRequestDetailsById(id).subscribe({
            next: response => {
                this.requestDetails = response;
                // this.default_currency = response.requestor.company?.default_currency;
                console.log("Default Currency check", this.default_currency)
                this.requestService.selectedRequest = {...response};
                this.ackRequest.selectedRequest = {...response};
                this.getQuotes(this.requestService.selectedRequest);

                this.externalAppUrl = `invoice/list/&sub_booking=${this.requestDetails?.arthakosh_id}`
                this.getStatusbyRequestId(response.status.id)
                this.getLocationLabels(response);
                // this.asPerStatus(response.status); //sets the viewFormContent
                if (this.mode != '') {
                    if (this.mode == 'ro')
                        this.viewFormContent = "release_order";
                    else if (this.mode == 'rr')
                        this.viewFormContent = "return_reference";
                } else {
                    if (response.status.default_option_dev_name == null) {
                        if (response.status.dev_name == 'quote_accepted_by_external_user')
                            this.viewFormContent = 'negotiate'
                        else
                            this.viewFormContent = "initial";
                    } else {
                        this.viewFormContent = response.status.default_option_dev_name;
                    }
                }
                //for selecting the menu with response
                switch (this.viewFormContent) {
                    case "release_order":
                        this.selected_menu = "operations";
                        this.selected_menu_item = "release_order";
                        break;
                    case "pickup_return":
                        this.selected_menu = "operations"
                        this.selected_menu_item = "pickup_return";
                        break;
                    case "return_reference":
                        this.selected_menu = "operations"
                        this.selected_menu_item = "return_reference";
                        break;
                    case "return":
                        this.selected_menu = "operations"
                        this.selected_menu_item = "return";
                        break;

                    default:
                        this.selected_menu = this.viewFormContent;
                        break;
                }

                this.loader = false;
                this.readTrigger = of(
                    setTimeout(() => {
                        this.markRequestAsRead(this.requestService.selectedRequest);
                        // call service to mark request as read (PUT) empty data
                    }, 5000)
                ).subscribe();

                this.showDialogIfFirstRequestFromCompany(response)
                this.requestError = false;
                return response;
            },
            error: error => {
                if (error.status > 399 && error.status < 499) {
                    this.requestError = true;
                }
                return error;
            }
        })
    }

    markRequestAsRead(request) {
        this.requestService.markAsRead(request).subscribe(() => {
        });
    }

    quoteResponse: any;

    // GET quotes for requirements
    getQuotes(request) {
         this.loaderService.showLoader();
        this.requestService.getBaseQuote(request).subscribe({
            next: response => {
                this.quoteResponse = response;
                if (this.requestService.selectedRequest.request_type.dev_name == 'lease') {
                    this.refreshLeaseQuote.next(response);
                }
                if (this.requestService.selectedRequest.request_type.dev_name == 'one_way') {
                    this.refreshOneWayQuote.next(response);
                }
                if (this.requestService.selectedRequest.request_type.dev_name == 'buy_sell') {
                    this.refreshTradeQuote.next(response);
                }

                if (this.requestService.selectedRequest.request_type.dev_name == 'empty_repo') {
                    this.refreshEmptyRepoQuote.next(response);
                }

                this.reviewQuoteData = response;

                if (this.requestDetails?.booking != null) {
                    this.getBookingDetails(this.requestDetails?.booking);
                }
            this.loaderService.hideLoader();
                return response;
            },
            error: error => {
                if (error.status == 404) {
                    if (this.requestService.selectedRequest.request_type.dev_name == 'lease') {
                        this.refreshLeaseQuote.next('error');
                    }
                    if (this.requestService.selectedRequest.request_type.dev_name == 'one_way') {
                        this.refreshOneWayQuote.next('error');
                    }
                    if (this.requestService.selectedRequest.request_type.dev_name == 'buy_sell') {
                        this.refreshTradeQuote.next('error');
                    }
                    if (this.requestService.selectedRequest.request_type.dev_name == 'empty_repo') {
                        this.refreshEmptyRepoQuote.next('error');
                    }
                }
                this.loaderService.hideLoader();
                return error;
            }
        });
    }

    getStatusbyRequestId(requestId) {
        this.possibleStatusChangeList = [];
        this.ackRequest.getRequestStatus(requestId).subscribe(response => {
            this.possibleStatusChangeList = response.results;
            this.reqAction[0].submenu = [...response.results];
        })
    }

    changeStatus(item, a, b, c) {
        if(item.dev_name=='rejected_by_internal_user_after_booking_confirmed'){
            this.requestService.bookingDetailsExpand= false;
        }
        this.ackRequest.selecteddevName = {...item}
        if (item.verb == 'Create Booking') {
            this.viewFormContent = 'negotiate';
            if (this.requestService.selectedRequest?.request_type?.dev_name == 'one_way')
                this.refreshOneWayQuote.next('review');
            if (this.requestService.selectedRequest?.request_type?.dev_name == 'buy_sell')
                this.refreshTradeQuote.next('review');
            if (this.requestService.selectedRequest?.request_type?.dev_name == 'lease') {
                this.leaseQuoteTable.reviewQuote('confirm');
                this.reviewLease = true;
            }a
            if (this.requestService.selectedRequest?.request_type?.dev_name == 'empty_repo')
                this.refreshEmptyRepoQuote.next('review');
        } else {
            this.viewFormContent = 'status_change';
            this.selected_menu = 'quick_actions';
            this.selected_menu_item = item.dev_name;

            this.changeToStatusCache = item;
            this.changeToStatusDevName = item.dev_name;
            this.attention = a;
            this.secondaryButton = b;
            this.ternaryButton = c;
            this.changeToStatusName = item.verb;
        }
    }

    changeViewFormContent(a, create: boolean = false) {
        this.viewFormContent = a;
        if (a == "release_order") {
            this.addRelease = create;
            this.selected_menu_item = a;
        } else if (a == "return_reference") {
            this.addReturn = create;
            this.selected_menu_item = a;
        } else if (a == "re_export") {
            this.addReexport = create;
            this.selected_menu_item = a;
        } else if (a == "movement_details") {
            this.addMovementDetails = create;
            this.selected_menu_item = a;
        }

    }

    showDialogIfFirstRequestFromCompany(request) {
        if (request != null) {
            if (!request.is_read) {
                if (request.requestor?.company?.is_virgin) {
                    // @TODO show dialog based on request.requestor.company.request_count
                    let text = `This is request count: ${request.requestor?.company?.request_count} from ${request.requestor?.first_name} ${request.requestor?.last_name} from <b>${request.requestor?.company?.legal_name ?? request.requestor?.company?.name}</b>.<br>`;
                    let text2 = `This could be a great opportunity to offer a competitive pricing to seal this deal. Suggest you to quote competitive to add <b>${request.requestor?.company?.legal_name ?? request.requestor?.company?.name}</b> to the ARCON Container's long-term business.<br><br>`;
                    let text3 = `Over To You!`

                    this.openNotificationDialog(`${text}${text2}${text3}`, 'OK, GOT IT')
                } else {
                    return;
                }
            } else {
                return;
            }
        }
    }

    openNotificationDialog(label: string, btnLabel: string) {
        const dialogRef = this.dialog.open(NotificationBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, label1: btnLabel}
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                return;
            }
        })
    }

    onRequestSelection(event) {
        if (event != null) {
            // console.log("patch request", event);
            this.chatService.noAccessToChat = false;
            this.router.navigateByUrl(`/requests/request-processing/request-details?id=${event.id}&type=${event.transaction_type}&rtype=${event.request_type.dev_name}`);
        }
    }

    // GET quotes for requirements
    getRequestMenuItems(requestId) {
        this.requestService.getRequestMenuItems(requestId).subscribe({
            next: response => {
                if (this.rType != 'empty_repo') {
                    console.log(response);
                    this.menuItems = response.map((menu: any) => ({
                        ...menu,
                        items: menu.items ? menu.items.filter(item => item.dev_name !== "movement_details") : []
                    }));
                } else {
                    this.menuItems = response;
                }
                for (let i = 0; i < this.menuItems.length; i++) {
                    if (this.menuItems[i].dev_name == 'quotations' || this.menuItems[i].dev_name == 'negotiate') {
                        this.previousMenu = this.menuItems[i].dev_name;
                    }
                }
            },
        });
    }

    menuClick(dev_name) {
        this.viewFormContent = dev_name;
        this.selected_menu = dev_name;
    }

    itemClick(dev_name, menu_dev_name) {
        this.viewFormContent = dev_name;
        this.selected_menu = menu_dev_name;
        this.selected_menu_item = dev_name
        console.log(dev_name, menu_dev_name, 'this is what i need');
        if (dev_name == "release_order") {
            this.addRelease = false;
        } else if (dev_name == "return_reference") {
            this.addReturn = false;
        } else if (dev_name == "re_export") {
            this.addReexport = false;
        } else if (dev_name == "movement_details") {
            this.addMovementDetails = true;
        }
        // this.skipFeedback = true;
        // console.log(this.skipFeedback, 'this.skipfeedback')
    }

    updateRequestPage() {
        this.viewFormContent = ''
        let id = this.requestService.selectedRequest?.id
        if (id == null) {
            return;
        }
        this.getRequestDetailsById(id);
        this.getRequestMenuItems(id);
        this.attention = true;
    }

    celebration(val) {
        this.celebrate = val;
    }

    feedbackSubmit(a) {
        // this.isFeedbackSubmited = a;
        // this.confirmationMessage = "Thanks for sharing your valuable feedback.";
    }

    getLocationLabels(request) {
        switch (request?.request_type?.dev_name) {
            case 'one_way':
                this.locationSourceLabel = 'Pick-up Location';
                this.locationDestinationLabel = 'Drop-off Location';
                break;
            case 'buy_sell':
                if (request.transaction_type == 'use') {
                    this.locationSourceLabel = 'Buy Location';
                } else {
                    this.locationSourceLabel = 'Sell Location';
                }
                break;
            case 'lease':
                this.locationSourceLabel = 'On-hire Location';
                this.locationDestinationLabel = 'Off-hire Location';
                break;
            case 'empty_repo':
                this.locationSourceLabel = 'Pick-up Location';
                this.locationDestinationLabel = 'Drop-off Location';
                break;
        }
    }

    reviewQuote(quoteData) {
        this.reviewQuoteData = quoteData;
        this.review = true;
    }

    reviewLeaseQuote(quoteData) {
        this.reviewQuoteData = quoteData;
        this.reviewLease = true;
    }

    onMouseMove(e: any) {
        this.notGettingDragged = true
        // console.log("this.notGettingDragged", this.notGettingDragged);
    }

    ifDown() {
        this.mouseDown = true;
        this.notGettingDragged = false;
        // console.log("this.notGettingDragged,this.mouseDown ", this.notGettingDragged,this.mouseDown);
    }

    chatViewToggle() {
        if (this.mouseDown) {
            if (this.notGettingDragged == false) {
                // console.log("it is 1, ", this.notGettingDragged);
                this.viewChat = !this.viewChat;
                if (this.viewFormContent !== 'quotations' && this.viewFormContent !== 'negotiate') {
                    this.menuClick("communication");
                }
                if (this.newNotificationFlag)
                    this.newNotificationFlag = false;
                this.chatService.resetDocumentTitle();
            } else if (this.notGettingDragged) {
                this.notGettingDragged = false;
                // console.log("it is2, ", this.notGettingDragged);
            }
        }

    }

    closeReview(event) {
        this.review = false;
        if (event) {
            this.updateRequestPage();
        }
    }

    closeLeaseReview(event) {
        this.reviewLease = false;
        this.child4.leaseDetailsExpand = true;
    }

    back() {
        this.reviewLease = false;
    }

    showQuickActionsForRejectedRequestForCustomer() {
        switch (this.requestService.selectedRequest?.status?.dev_name) {
            case 'rejected_by_external_user_after_booking_confirmed':
            case 'reject_by_internal_user':
            case 'cancelled_by_external_user_after_booking_confirmed':
            case 'cancelled_by_external_user':
            case 'reject_by_internal_user_after_acceptance':
            case 'cancelled_by_external_user_after_acceptance':
            case 'rejected_by_internal_user_after_sending_quote':
            case 'rejected_by_internal_user_after_booking_confirmed':
                return false;
            default:
                return true;
        }
    }

    cloneRequest() {
        // this.router.navigateByUrl(`requests/request-data`);
        this.router.navigateByUrl(`/requests/request-processing/request-details?id=${this.requestService.selectedRequest.id}&type=${this.requestService.selectedRequest?.transaction_type}&rtype=${this.requestService.selectedRequest?.request_type?.dev_name}`);

    }

    getBookingDetails(booking: string) {
        this.loader = true;
        this.requestService.getBookingDetailsById(booking).subscribe({
            next: response => {
                console.log('getBookingDetails', response);
                // if (this.type == 'use')
                //     this.reviewQuoteData = response;
                this.bookingDetails = response;
                this.requestService.requirementList = response.requirements;
                console.log("check booking",this.bookingDetails)
                this.loader = false;
                return response;
            },
            error: error => {
                this.loader = false;
                if (error.status > 399 && error.status < 499) {
                    this.requestError = true;
                }
                return error;
            }
        })
    }

    goto_url: string = 'invoice/list'

    gotoApp() {
        if (this.goto_url != '') {
            let encodedUrl = encodeURIComponent(this.goto_url)
            console.log("this.goto_url",environment.arthakoshFrontendBaseUrl + '/authentication/handshake/?url=' + encodedUrl)
            window.open(environment.arthakoshFrontendBaseUrl + '/authentication/handshake/?url=' + encodedUrl, '_blank');
        }
    }

    showContainers(data: any) {
        this.reqContainers.emit(data);
    }
    showReopenLogs(data: any) {
        this.reopenLogs.emit(data);
    }
    showLogs(data:any){
        this.bookingViewLogs.emit(data)
    }
    invoiceParty(data: any) {
        this.addInvoiceParty.emit(data);
    }
}
